import { setIsLoading } from '@/pages/EngagementDetails/ApplicationDetail/DeveloperEvidence/DeveloperEvidenceSlice'
import { sodApi } from '@/services/index'
// Define a service using a base URL and expected endpoints
export const EvidenceApi = sodApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadEvidence: builder.mutation({
      query: ({ applicationId, evidenceType, formData }) => ({
        url: `/Evidence/Upload/${applicationId}/${evidenceType}`,
        method: 'POST',
        body: formData,
      }),
    }),
    cancelEvidence: builder.mutation<any, any>({
      query: (body) => ({
        url: `/Evidence/Cancel`,
        method: 'POST',
        body,
      }),
    }),
    confirmEvidence: builder.mutation<any, any>({
      query: ({ body, environment }) => ({
        url: `/Evidence/Confirm?env=${environment}`,
        method: 'POST',
        body,
      })
    }),
    deleteEvidence: builder.query<any, any>({
      query: (evidenceId) => ({
        url: `/Evidence/Delete/${evidenceId}`,
        method: 'GET',
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          dispatch(setIsLoading(true))
          const { data } = await queryFulfilled
          dispatch(setIsLoading(false))
        } catch (error) {
          console.error('Error fetching evidence:', error)
        }
      }
    }),
    supplymentEvidence: builder.mutation<any, any>({
      query: ({ groupId, body }) => ({
        url: `/Evidence/supplement/${groupId}/upload`,
        method: 'POST',
        body,
      }),
    }),
    listEvidence: builder.query<any, any>({
      query: ({ applicationId, evidenceType, summary }) => ({
        url: `/Evidence/list/${applicationId}/${evidenceType}`,
        method: 'GET',
        // summary=true skips per-item annotation/system-account enrichment on
        // the BE — use it for lightweight readiness checks (e.g. the
        // Appropriateness page's unverified-evidence banner).
        params: summary ? { summary: true } : undefined,
      }),
    }),
    getEnvironment: builder.query<any, void>({
      query: () => ({
        url: `/Environment`,
        method: 'GET',
      }),
    }),
  }),
})
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useUploadEvidenceMutation,
  useCancelEvidenceMutation,
  useConfirmEvidenceMutation,
  useLazyDeleteEvidenceQuery,
  useSupplymentEvidenceMutation,
  useListEvidenceQuery,
  useGetEnvironmentQuery,
} = EvidenceApi
